import { getScale } from '../canvas/selectors'
import { updateImageReferencePosition } from '../canvas/actions'

export const ROTATE_LEFT = 'ROTATE_LEFT'
export const rotateLeft = () => ({ type: ROTATE_LEFT })

export const ROTATE_RIGHT = 'ROTATE_RIGHT'
export const rotateRight = () => ({ type: ROTATE_RIGHT })

export const LOCK = 'LOCK'
export const lock = () => ({ type: LOCK })

export const RESET = 'RESET'
export const reset = () => ({ type: RESET })

export const CONTRAST = 'CONTRAST'
export const contrast = (contrastLevel) => ({ type: CONTRAST, contrastLevel })

export const BRIGHTNESS = 'BRIGHTNESS'
export const brightness = (brightnessLevel) => ({ type: BRIGHTNESS, brightnessLevel })

export const INVERT = 'INVERT'
export const invert = () => ({ type: INVERT })

export const ZOOM = 'ZOOM'
export const zoom = (scale) => ({ type: ZOOM, scale })

export const ZOOM_IN = 'ZOOM_IN'
export const zoomIn = () => ({ type: ZOOM_IN })

export const ZOOM_OUT = 'ZOOM_OUT'
export const zoomOut = () => ({ type: ZOOM_OUT })

export const zoomInRelativeToPointerPosition = (pointerPosition, viewId) => (dispatch, getState) => {
    const previousScale = getScale(getState(), viewId)

    dispatch(zoomIn())

    const currentScale = getScale(getState(), viewId)
    dispatch(updateImageReferencePosition(currentScale, computeZoomTranslationVector(pointerPosition, previousScale, currentScale)))
}

export const zoomOutRelativeToPointerPosition = (pointerPosition, viewId) => (dispatch, getState) => {
    const previousScale = getScale(getState(), viewId)

    dispatch(zoomOut())

    const currentScale = getScale(getState(), viewId)
    dispatch(updateImageReferencePosition(currentScale, computeZoomTranslationVector(pointerPosition, previousScale, currentScale)))
}

export const computeZoomTranslationVector = (pointerPosition, previousScale, currentScale) => {

    const mousePositionVector = pointerPosition.convertToVector()

    return mousePositionVector
        .unscale(currentScale)
        .add(mousePositionVector
            .unscale(previousScale)
            .invert()
        )
        .scale(currentScale)
}
